<template>
  <div class="section-post-creator" :class="[mode, { 'conciergerie-edit': mode === 'update' && isFacebookConciergerieEdit }]">

    <header>
      <div class="container-title">

        <div class="btn-back" @click="$router.push('/dash/posts2');"></div>
        <div class="text">
          <h2 class="title">{{title}}</h2>
          <p v-if="!previewMode.active && ['create','duplicate'].includes(mode) && canRestoreDraft" class="switchOldVersion" @click="$emit('retoreDraftInLocalStorage')">{{ $t('dash.post-creator.action.restore-draft') }}</p>
          <p v-else-if="mode !== 'create'" class="switchOldVersion" @click="$router.push('/dash/posts2');">{{ $t('dash.post-creator.back-to-planner') }}</p>
        </div>

      </div>
      <!-- button personalisation -->
      <div class="custom-edtion-mode" v-if="!previewMode.active && switchModeShow">
        <h5 @click="handleChangecustomMode()">{{ $t('dash.post-creator.custom-mode.title') }}</h5>

        <ComponentSwitch 
          :value="draftInstance.form.merge.target !== 'main'" 
          :onChange="(value)=>handleChangecustomMode(value)" 
          :id="'switchEditionMode'"
        />
        
        <p 
          class="state-edition-mode" 
          @click="handleChangecustomMode()">
          {{draftInstance.form.merge.target == 'main' ? $t('dash.post-creator.custom-mode.disabled') : $t('dash.post-creator.custom-mode.enabled') }}
        </p>

        <div class="tutorial" v-if="draftInstance.form.merge.target == 'main' && showTutorial">
          <svg width="29" height="31" viewBox="0 0 29 31" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M7.61478 29.4303C3.46662 10.3949 6.9428 1.2045 27.9404 0.99937M7.61478 29.4303L1.21998 23.77M7.61478 29.4303L12.2981 22.1357" stroke="#B64985" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
          {{ $t('dash.post-creator.custom-mode.hint') }}
        </div>
      </div>

      <div class="btns-action">
        <template v-if="previewMode.active">
          <div class="btn-outline-primary" @click="()=>handlerChangePreviewDisplay(false)">{{ $t('dash.button.go_back') }}</div>

          <div v-if="!isFileUploading" class="btn-secondary icon-r " @click="sendPostAllPost">
            {{textBtnFinish || 'Error'}}
            <i class="fa-solid fa-arrow-right"></i>
          </div>


          <Tooltip v-else :text="$t('dash.post-creator.media.uploading')" :active="isFileUploading" :classCustom="'btn-secondary icon-r disable'" position="bottom">
            {{textSwitchPreview}}
            <i class="fa-solid fa-arrow-right"></i>
          </Tooltip>

        </template>

        <template v-else>
          <template  v-if="mode !== 'update' && draftInstance.form.planifiedDate.date" >
            <div v-if="draftInstance.usersAssigned.includes(currentUser.id)" class="btn assign" @click="unassignCurrentUser">
              {{ $t('dash.post-creator.user.unassign') }}
              <i class="fa-solid fa-user-minus"></i>
            </div>
            <div v-else class="btn assign" @click="assignUsers">
              {{ $t('dash.post-creator.user.assign') }} {{ draftInstance.usersAssigned.length ? `(${draftInstance.usersAssigned.length})` : '' }}
              <i class="fa-solid fa-user-plus"></i>
            </div>
          </template>


          <Tooltip
            :text="$t('dash.post-creator.media.uploading')"
            :active="false && isFileUploading"
            position="bottom"
          >
            <div
              v-if="mode !== 'update' && !(draftInstance.form.planifiedDate.date && draftInstance.usersAssigned.length && draftInstance.usersAssigned.requiredValidation)"
              class="btn-outline-primary"
              :class="{'disable': false && isFileUploading}"
              @click="saveDraft">
              {{{ create : $t('dash.post-creator.action.save-draft'), duplicate : $t('dash.post-creator.action.save-draft'), edit: $t('dash.post-creator.action.convert-to-draft'), draft : $t('dash.post-creator.action.save')}[mode || 'create']}}
            </div>
          </Tooltip>

          <Tooltip
            :text="$t('dash.post-creator.media.uploading')"
            :active="isFileUploading"
            position="bottom"
          >
            <div
              class="btn-secondary icon-r"
              :class="{'disable': isFileUploading}"
              @click="()=>handlerChangePreviewDisplay(true)">
              {{textSwitchPreview}}
              <i class="fa-solid fa-arrow-right"></i>
            </div>
          </Tooltip>


        </template>




      </div>
    </header>

    <div :class="'post-creator '+formShow" ref="postCreator" >
      <div class="container-form" v-if="formShow == 'formMultiple'">
        <div class="nav-type-post">
          <div class="icon-l btn-primary"><i class="fa-solid fa-pen-to-square"></i>Standard</div>
          <div 
            v-if="draftInstance.form.networks.instagram.storification.pagesActived.length" 
            @click.stop="() => $emit('toogleStorificationTab')" 
            class="icon-l"
          >
            <i class="fa-solid fa-share-from-square"></i>
            Partage en story
          </div>
         
        </div>
        <div class="container-form-scroll hide-scrollbar">
          <div class="form">
            <div class="list-pages-selected">
              <div v-if="mode !== 'update'" class="btn-add-page" :class="{retract: pagesSelected.length}" @click="openSelectPage">
                <i class="fa-solid fa-plus"></i>
                <p>{{ $t('dash.post-creator.pages.add') }}</p>
              </div>
              <div class="container-list-avatars hide-scrollbar">
                <div class="list-avatars hide-scrollbar">
                  <Tooltip
                    v-for="page in draftInstance.pages.items"
                    :text="page.name"
                    :key="page.id"
                  >
                  <ContextMenu 
                    :options="customModeIsAvailable ?
                      [
                        {label:'Retirer la page',name:'removePage'},
                        {label:'Personnaliser la page',name:'customPage'}
                      ] : [
                        {label:'Retirer la page',name:'removePage'}
                      ]
                    " 
                    :id="'contextMenuPage'+page.id" 
                    v-on:clickOption="(_, name)=> clickContextMenuPage(name, page)"
                  >
                    <Avatar :urlPicture="page.avatar" :typeNetwork="page.network"></Avatar>
                  </ContextMenu>
                  
                  </Tooltip>
                </div>
              </div>
            </div>
            <Form
              @setSelectTypeRenderNetwork="selectTypeNetwork"
              @addFile="(...args)=>this.$emit('addFile',...args)"
              :files="files"
              :typeRenderNetworkSelected="typeNetworkSelected"
              :formData="formData"
              :networksSelected="networksSelected"
              :draftInstance="draftInstance"
            >
            </Form>
          </div>
        </div>
      </div>

      <div class="container-phone" ref="containerPhone">
        <div class="nav-type-network" v-if="draftInstance.form.merge.target == 'main'">
          <div class="list-network">
            <template v-for="networkName in listNetworkSort">
              <Tooltip
                :key="networkName"
                v-if="networksSelected.includes(networkName)"
                :text="
                    mode == 'update' && !editableNetworks.includes(networkName) ? 
                        $t('dash.post-creator.error.network-edit-impossible') :
                        draftInstance.form.networks[networkName].validator.error
                "
                :active="
                  (mode == 'update' && !editableNetworks.includes(networkName)) ||   
                  !draftInstance.form.networks[networkName].validator.isValid
                "
                position="left"
              >
                <div class="network" 
                  :class="{
                    active: typeNetworkSelected == networkName, 
                    disable : !draftInstance.form.networks[networkName].validator.isValid, 
                    [networkName] : true
                  }" 
                  @click="selectTypeNetwork(networkName)"
                >
                  <Tooltip
                    v-if="draftInstance.form.merge.saveAllFormData.networks[networkName]"
                    :text="$t('dash.post-creator.custommode.see-changes')"
                    position="right"
                    :classCustom="`icon-edited`"
                    @click="()=>{
                      handleChangecustomMode(true, networkName); 
                    }"
                  />

                  <svg v-if="networkName == 'bluesky'" viewBox="0 0 640 640"><path d="M439.8 358.7C436.5 358.3 433.1 357.9 429.8 357.4C433.2 357.8 436.5 358.3 439.8 358.7zM320 291.1C293.9 240.4 222.9 145.9 156.9 99.3C93.6 54.6 69.5 62.3 53.6 69.5C35.3 77.8 32 105.9 32 122.4C32 138.9 41.1 258 47 277.9C66.5 343.6 136.1 365.8 200.2 358.6C203.5 358.1 206.8 357.7 210.2 357.2C206.9 357.7 203.6 358.2 200.2 358.6C106.3 372.6 22.9 406.8 132.3 528.5C252.6 653.1 297.1 501.8 320 425.1C342.9 501.8 369.2 647.6 505.6 528.5C608 425.1 533.7 372.5 439.8 358.6C436.5 358.2 433.1 357.8 429.8 357.3C433.2 357.7 436.5 358.2 439.8 358.6C503.9 365.7 573.4 343.5 593 277.9C598.9 258 608 139 608 122.4C608 105.8 604.7 77.7 586.4 69.5C570.6 62.4 546.4 54.6 483.2 99.3C417.1 145.9 346.1 240.4 320 291.1z"/></svg>
                  <svg v-else-if="networkName == 'threads'" viewBox="0 0 192 192" width="100%" height="100%"><path d="M141.537 88.9883C140.71 88.5919 139.87 88.2104 139.019 87.8451C137.537 60.5382 122.616 44.905 97.5619 44.745C97.4484 44.7443 97.3355 44.7443 97.222 44.7443C82.2364 44.7443 69.7731 51.1409 62.102 62.7807L75.881 72.2328C81.6116 63.5383 90.6052 61.6848 97.2286 61.6848C97.3051 61.6848 97.3819 61.6848 97.4576 61.6855C105.707 61.7381 111.932 64.1366 115.961 68.814C118.893 72.2193 120.854 76.925 121.825 82.8638C114.511 81.6207 106.601 81.2385 98.145 81.7233C74.3247 83.0954 59.0111 96.9879 60.0396 116.292C60.5615 126.084 65.4397 134.508 73.775 140.011C80.8224 144.663 89.899 146.938 99.3323 146.423C111.79 145.74 121.563 140.987 128.381 132.296C133.559 125.696 136.834 117.143 138.28 106.366C144.217 109.949 148.617 114.664 151.047 120.332C155.179 129.967 155.42 145.8 142.501 158.708C131.182 170.016 117.576 174.908 97.0135 175.059C74.2042 174.89 56.9538 167.575 45.7381 153.317C35.2355 139.966 29.8077 120.682 29.6052 96C29.8077 71.3178 35.2355 52.0336 45.7381 38.6827C56.9538 24.4249 74.2039 17.11 97.0132 16.9405C119.988 17.1113 137.539 24.4614 149.184 38.788C154.894 45.8136 159.199 54.6488 162.037 64.9503L178.184 60.6422C174.744 47.9622 169.331 37.0357 161.965 27.974C147.036 9.60668 125.202 0.195148 97.0695 0H96.9569C68.8816 0.19447 47.2921 9.6418 32.7883 28.0793C19.8819 44.4864 13.2244 67.3157 13.0007 95.9325L13 96L13.0007 96.0675C13.2244 124.684 19.8819 147.514 32.7883 163.921C47.2921 182.358 68.8816 191.806 96.9569 192H97.0695C122.03 191.827 139.624 185.292 154.118 170.811C173.081 151.866 172.51 128.119 166.26 113.541C161.776 103.087 153.227 94.5962 141.537 88.9883ZM98.4405 129.507C88.0005 130.095 77.1544 125.409 76.6196 115.372C76.2232 107.93 81.9158 99.626 99.0812 98.6368C101.047 98.5234 102.976 98.468 104.871 98.468C111.106 98.468 116.939 99.0737 122.242 100.233C120.264 124.935 108.662 128.946 98.4405 129.507Z"/></svg>
                  <svg v-else-if="networkName == 'twitter'" viewBox="0 0 300 271" width="100%" height="100%"><path d="m236 0h46l-101 115 118 156h-92.6l-72.5-94.8-83 94.8h-46l107-123-113-148h94.9l65.5 86.6zm-16.1 244h25.5l-165-218h-27.4z"/></svg>
                  <i v-else-if="networkName == 'linkedin'" class="fa-brands fa-linkedin-in"></i>
                  <i v-else :class="`fa-brands fa-${networkName}`"></i>
                </div>
              </Tooltip>
            </template>

          </div>
        </div>

        <!-- switch entre post standard ou parte en story dans la preview -->
        <div class="switch-preview-post-type" v-if="previewMode.active && previewMode.pageSelected && previewMode.pageSelected.network == 'instagram' && pagesInstagramActivedShareStory.some((page) => page.id == previewMode.pageSelected.id)">
          <div class="btn-primary">Standard</div>
          <div class="" @click.stop="()=>$emit('changeTab','story_share')">Story</div>
        </div>

        <Phone :firstPlan="phoneIsFirstPlan">
          <renderPostFailed
            v-if="textPostFailed"
            :textError="textPostFailed"
          />

          <renderPostManager
            :typeNetworkSelected="draftInstance.form.merge.target == 'main' ? typeNetworkSelected : draftInstance.form.merge.target.network || draftInstance.form.merge.target"
            :formData="formData"
            :draft="draftInstance"
            :files="files"
            :pages="pageForRenderPost"
            :idsPagesStatusEdited="pageForRenderPost.length > 1 ? idsPagesEditedForRenderPost : []"
            :positionFormOverlay="draftInstance.form.merge.target == 'main' ? 'left' : 'right'"
            :modes="modes"
            @clickPageInRenderPost="clickPageInRenderPost"

          />


          <!-- overlay -->
          <selectMention v-if="modes.includes('addMentionMode')"
            @close="removeMode"
            :position="draftInstance.form.merge.target == 'main' ? 'left' : 'right'"
            :mentionData="dataMode.addMentionMode && dataMode.addMentionMode.mention ? dataMode.addMentionMode.mention : {}"
            :idMention="dataMode.addMentionMode && dataMode.addMentionMode.idMention ? dataMode.addMentionMode.idMention : null"
            :networks="dataMode.addMentionMode && dataMode.addMentionMode.networks ? dataMode.addMentionMode.networks : null"
            :text="dataMode.addMentionMode && dataMode.addMentionMode.text ? dataMode.addMentionMode.text : null"
            :mentions="formData.mentions"
            :close="dataMode.addMentionMode && dataMode.addMentionMode.close ? dataMode.addMentionMode.close : null"
            :searchMention="dataMode.addMentionMode && dataMode.addMentionMode.searchMention ? dataMode.addMentionMode.searchMention : null"
            :removeMention="dataMode.addMentionMode && dataMode.addMentionMode.removeMention ? dataMode.addMentionMode.removeMention : null"
            :addMention="dataMode.addMentionMode && dataMode.addMentionMode.addMention ? dataMode.addMentionMode.addMention : null"
          />
          <selectHashtag v-if="modes.includes('addHashtagMode')"
            @close="removeMode"
            :position="draftInstance.form.merge.target == 'main' ? 'left' : 'right'"
            :id="dataMode.addHashtagMode && dataMode.addHashtagMode.id ? dataMode.addHashtagMode.id : ''"
            :searchHashtags="dataMode.addHashtagMode && dataMode.addHashtagMode.searchHashtags ? dataMode.addHashtagMode.searchHashtags : null"
            :apply="dataMode.addHashtagMode && dataMode.addHashtagMode.apply ? dataMode.addHashtagMode.apply : null"
          />

          <inputOverlay
            v-if="modes.includes('inputMode')"
            v-bind="dataMode.inputMode"
            :position="draftInstance.form.merge.target == 'main' ? 'left' : 'right'"
            @close="removeMode"
          />
        </Phone>

        <div class="nav-page-standard" v-if="previewMode.active">
          <div class="list-page hide-scrollbar">
            <template v-for="(networkName, index) in draftInstance.pages.networksSelected">
              <div
                class="group"
                :key="networkName"
              >
                <div class="network"
                    :class="{
                        [networkName]:true,
                        failed: draftInstance.pages.some(page => page.network == networkName && requests && requests.posts && requests.posts[page.id] &&  requests.posts[page.id].message)
                    }"

                    @click="()=>{
                        $emit('changePreviewDisplay', true, draftInstance.pages.pagesByNetwork[networkName][0]);
                        draftInstance.form.merge.run(draftInstance.pages.pagesByNetwork[networkName][0]);
                        
                    }"
                >
                </div>
                <div class="list-avatar">
                  <div class="container-avatar"
                       v-for="page in draftInstance.pages.pagesByNetwork[networkName]"
                       :class="{
                            checked: (previewMode.pageSelected && previewMode.pageSelected.id == page.id),
                            failed: requests && requests.posts && requests.posts[page.id] &&  requests.posts[page.id].message
                        }"
                       :key="page.id"
                  >

                    <Tooltip :text="page.name" :active="true" position="right">
                      <Avatar
                        @click="()=>{
                            $emit('changePreviewDisplay',true, page);
                            draftInstance.form.merge.run(page);
                        }"
                        :checkIsPossible="true"
                        :checked="(previewMode.pageSelected && previewMode.pageSelected.id == page.id)"
                        :urlPicture="page.avatar"
                      />
                    </Tooltip>
                  </div>
                </div>
              </div>
            </template>
          </div>
        </div>

        <div class="nav-page-standard" v-else>
          <div class="list-page hide-scrollbar">
            <template v-for="(networkName, index) in draftInstance.pages.networksSelected">
              <div
                class="group"
                :key="networkName"
                :class="{'active': draftInstance.form.merge.target == networkName}"
              >
                <div class="network"
                    :class="{
                        [networkName]:true,
                        edited: saveAllFormData.networks[networkName] && Object.keys(saveAllFormData.networks[networkName]).length > 0,
                        failed: previewMode.active && pagesSelected.some(page => page.network == networkName && dataFormRequest[page.id] &&  dataFormRequest[page.id].error)
                    }"
                    @click="() => draftInstance.form.merge.run(networkName)"
                >
                  <Checkbox 
                    v-if="draftInstance.form.merge.target !== networkName" 
                    :isChecked="draftInstance.form.merge.target == networkName" 
                    :add="draftInstance.form.merge.run" 
                    :isDisable="draftInstance.form.merge.target == networkName" 
                    :prefexId="'networkcustomModePostCreator'+index" 
                    :id="networkName"
                  />
                </div>
                <div class="list-avatar">
                  <div class="container-avatar"
                       v-for="page in draftInstance.pages.pagesByNetwork[networkName]"
                       :class="{
                            checked: (draftInstance.form.merge.target.id && draftInstance.form.merge.target.id == page.id) || draftInstance.form.merge.target == networkName,
                            edited: draftInstance.form.merge.saveAllFormData.pages[page.id],
                        }"
                       :key="page.id"
                  >
                    <Tooltip :text="page.name" :active="true" position="right">
                      <Avatar @click="()=>draftInstance.form.merge.run(page)"
                        :checkIsPossible="true"
                        :checked="(draftInstance.form.merge.target.id && draftInstance.form.merge.target.id == page.id) || draftInstance.form.merge.target == networkName"
                        :urlPicture="page.avatar"
                      />
                    </Tooltip>
                  </div>
                </div>
              </div>
            </template>
          </div>
        </div>
      </div>

      <template v-if="formShow == 'formUnique'" >

        <div class="container-form">
          <div class="container-form-scroll hide-scrollbar" style="align-items: flex-end">
            <div class="form">
              <Form
                :typeRenderNetworkSelected="draftInstance.form.merge.target.id ? draftInstance.form.merge.target.network : draftInstance.form.merge.target"
                :idPageRenderNetworkSelected="draftInstance.form.merge.target.id"
                :formData="formData"
                @addFile="(...args)=>this.$emit('addFile',...args)"
                :files="files"
                :personalizationMode="true"
                :networksSelected="networksSelected"
                @setSelectTypeRenderNetwork="selectTypeNetwork"
                :draftInstance="draftInstance"
              />
            </div>
          </div>
        </div>
        <div></div>
      </template>
    </div>
  </div>
</template>

<script>
import { EventBus } from '@/event-bus';
import store from '@/store/index.js';
import ComponentSwitch from '@/components/dash/utils/switch.vue';
import Avatar from '../utils/avatar.vue';
import Checkbox from '@/components/dash/utils/checkbox.vue';
import Phone from './components/Phone.vue';
import Form from './components/standardTab/Form.vue';
import selectMention from './components/formOverlay/selectMention.vue'
import selectHashtag from './components/formOverlay/selectHashtag.vue'
import input from './components/formOverlay/input.vue'
import Tooltip from '@/components/dash/tooltip/tooltipInit.vue'
import renderPostManager from './components/standardTab/RenderPostManager.vue';
import ContextMenu from '@/components/dash/contextMenu/contextMenuInit.vue'
import renderPostFailed from "./components/standardTab/renderPost/renderPostFailed.vue"


import { listNetworkSort,  formDataDefault, editableNetworks} from './constante.js'
import {
  postNetworkValidator,
  getFilesByNetwork,
  deepClone,
  mergeUpdates,
  unescapeSpecialChars,
  customModeIsAvailable
} from './utils.js'

import postMixin from '@/components/mixins/Posts.vue'
import draftMixin from '@/components/mixins/Drafts.vue'
import PostCreatorMixin from './mixins/main.js';
import { VueDraft } from '@mashupweb/draft-lib';
export default {
  components: {
    ComponentSwitch,
    Phone,
    Form,
    Avatar,
    Checkbox,
    selectMention,
    selectHashtag,
    inputOverlay: input,
    renderPostFailed,
    renderPostManager,
    Tooltip,
    ContextMenu
  },
  mixins: [postMixin, draftMixin, PostCreatorMixin],

  props: {
    mode: String,
    files: Object,
    isFileUploading:Boolean,
    formData: Object,
    saveAllFormData: Object,
    dataFormRequest: Object,
    previewMode: Object,
    idUsersAssigned:Array,
    requiredValidation:Boolean,
    canRestoreDraft:Boolean,
    draftInstance:VueDraft,
    requests: Array,
  },

  data() {
    return {
      renderCount: 0,
      listNetworkSort,
      editableNetworks,



      formShow: "formMultiple",// pour l'annimation
      timeOutAnnimateForm: null,
      typeNetworkSelected: "", //pour le telphone donc renomer la variable


      //la list mode est connu et modifiable par tout les interfaces Network et les deux formulaires
      modes : [],
      dataMode : {},

      showTutorial : !localStorage.postCreatorCountUsecustomMode ? true : localStorage.postCreatorCountUsecustomMode < 3,

      pagesInstagramActivedShareStory: []
    }
  },

  mounted() {
    EventBus.$on('postCreatorAddMode', this.addMode);
    EventBus.$on('postCreatorRemoveMode', this.removeMode);
    this.updateTypeNetworkSelected()
    this.setPagesInstagramActivedShareStory()
  },

  methods: {
    clickContextMenuPage(name, page) {
      switch (name) {
        case 'removePage':
          this.removePage(page.id)
          break;
        case 'customPage':
          if (this.customModeIsAvailable)  this.handleChangecustomMode(true, null, page)
         
          break;
      }
    },

    ///////////// METHOD SWITCH MODE /////////////

    handleChangecustomMode(state = null, network = null, page = null) {
      if (state == null) state = this.draftInstance.form.merge.target == 'main'

      if (state) {
        if (this.$refs.postCreator && this.$refs.postCreator.classList) {
          this.$refs.postCreator.classList.add('annimate-switch-edition-mode');
        }
        if (this.$refs.postCreator && this.$refs.postCreator.style) {
          this.$refs.postCreator.style.transform = `translateX(calc(-100% + ${this.$refs.containerPhone ? this.$refs.containerPhone.clientWidth : 0}px))`
        }

        if (this.timeOutAnnimateForm) clearTimeout(this.timeOutAnnimateForm)

        this.timeOutAnnimateForm = setTimeout(() => {

          this.draftInstance.form.merge.run(
            network ?? page ?? this.typeNetworkSelected
          )

          this.timeOutAnnimateForm = setTimeout(() => {
            if (this.$refs.postCreator && this.$refs.postCreator.classList) {
              this.$refs.postCreator.classList.remove('annimate-switch-edition-mode');
            }
            if (this.$refs.postCreator && this.$refs.postCreator.style) {
              this.$refs.postCreator.style.transform = ``
            }
            this.formShow = "formUnique"
          }, 0);
        }, 200);

        if (!localStorage.postCreatorCountUsecustomMode || localStorage.postCreatorCountUsecustomMode < 3) {
          if (!localStorage.postCreatorCountUsecustomMode) localStorage.setItem('postCreatorCountUsecustomMode', 1)
          else localStorage.setItem('postCreatorCountUsecustomMode', localStorage.postCreatorCountUsecustomMode + 1)
        }

      }else{
        if (this.$refs.postCreator && this.$refs.postCreator.classList) {
          this.$refs.postCreator.classList.add('annimate-switch-edition-mode');
        }
        if (this.$refs.postCreator && this.$refs.postCreator.style) {
          this.$refs.postCreator.style.transform = `translateX(calc(100% - ${this.$refs.containerPhone ? this.$refs.containerPhone.clientWidth : 0}px))`
        }
        if (this.timeOutAnnimateForm) clearTimeout(this.timeOutAnnimateForm)

        this.$nextTick(() => {
          this.timeOutAnnimateForm = setTimeout(() => {

            this.timeOutAnnimateForm = setTimeout(() => {
              if (this.$refs.postCreator && this.$refs.postCreator.classList) {
                this.$refs.postCreator.classList.remove('annimate-switch-edition-mode');
              }
              if (this.$refs.postCreator && this.$refs.postCreator.style) {
                this.$refs.postCreator.style.transform = ``
              }
              this.formShow = "formMultiple" //detruit le form de droite
              this.draftInstance.form.merge.run('main')
            }, 0);
          }, 200);
        })
      }
    },

    async handlerChangePreviewDisplay(state) {
      if (state) {
        if (!this.isFileUploading) {
          //this.generateStoryShare()
        }

        

        
      }else{

      }

      this.$emit('changePreviewDisplay',state)
    },

   

    clickPageInRenderPost(idPage) {
      const page = this.pagesSelected.find(p => p.id == idPage)
      if (this.switchModeShow && page) {
        if (this.draftInstance.form.merge.target == 'main') {
          this.handleChangecustomMode(true, null, page)
        }else{
          this.draftInstance.form.merge.run(page)
        }
      }
    },

    generateFormData(pageOrNetwork) {
      this.$emit('generateFormData', pageOrNetwork)
    },

    ///////////// METHOD NAVIGATION /////////////

    switchTab() {
      this.generateStoryShare()
      this.generateFormData()
      this.$emit("changeTab", 'story_share')
    },

    selectTypeNetwork(typeNetwork) {
      if (this.mode == 'update' && !editableNetworks.includes(typeNetwork)) return
      if (!this.draftInstance.form.networks[typeNetwork].validator.isValid) return
      this.typeNetworkSelected = typeNetwork
    },

    openSelectPage() {
      this.$store.commit('selectPage/updateSelectPageListRetracted', !this.$store.getters['selectPage/selectPageStateListRetracted'])
    },

    addMode(mode, data = {}) {
      if (!this.modes.includes(mode)) this.modes = [...this.modes,mode]
      this.$set(this.dataMode, mode, data)
    },

    removeMode(mode = 'all') {
      if (mode == 'all') {
        this.modes = []
        return
      }
      this.modes = this.modes.filter(v => v !== mode)
    },

    switchInterface() {
      localStorage.setItem('version_', 'old')
      this.$router.push({
        name: 'planner',
        params: {
          newPost: true
        }
      })
    },

    updateTypeNetworkSelected() {
     
      if (this.draftInstance.form.merge.target !== 'main') return
      if (this.draftInstance.pages.networksSelected.length == 0) return
      
      if (
          !this.typeNetworkSelected ||
          !this.draftInstance.pages.networksSelected.includes(this.typeNetworkSelected) ||
          !this.draftInstance.form.networks[this.typeNetworkSelected]?.validator?.isValid
      ) {
        this.typeNetworkSelected = this.draftInstance.pages.networksSelected.find((network) => {
          return this.draftInstance.form.networks[network]?.validator?.isValid
        })

        if (!this.typeNetworkSelected) {
          this.typeNetworkSelected = this.draftInstance.pages.networksSelected[0]
        }
      }
    },

    unassignCurrentUser() {
      this.$emit('unassignCurrentUser')
    },

    assignUsers() {
      this.$emit('assignUsers')
    },

    removePage(pageId) {
      if (this.mode == 'update') return
      const pagesSelected =  this.pagesSelected.filter(page => page.id !== pageId)
      this.$store.commit('selectPage/updatePagesSelected', {pagesId: pagesSelected.map(p => p.id)});

      //pour planner old
      localStorage.setItem('last_selected_pages',JSON.stringify(pagesSelected))
    },

    //////////// METHOD FOR FORMDATA ////////////


    ////////////////// SORT DATA //////////////////

    setPagesInstagramActivedShareStory() {
      return
      console.log("setPagesInstagramActivedShareStory",JSON.parse(JSON.stringify(this.saveAllFormData)))
      let defaultActivedShareStory = this.customMode.active ? (this.saveAllFormData.main.formDataNetwork.instagram.storification ? this.saveAllFormData.main.formDataNetwork.instagram.storification.active : null)
        : (this.formData.formDataNetwork.instagram.storification ? this.formData.formDataNetwork.instagram.storification.active : null)

      //regarde si la valeur de storification dans la customisation de instagram
      let saveNetworkIsActiveStory = null

      if (
        this.customModeIsAvailable &&
        this.saveAllFormData.networks?.['instagram']?.formDataNetwork?.instagram?.storification?.hasOwnProperty('active')
      ) {
        saveNetworkIsActiveStory =  this.saveAllFormData.networks['instagram'].formDataNetwork.instagram.storification.active
      }

      this.pagesInstagramActivedShareStory = this.pagesSelected.filter(page => {

        let isActived
        if (page.network !== 'instagram') {
          isActived = false
        }else if (
          this.customModeIsAvailable &&
          this.saveAllFormData.pages?.[page.id]?.formDataNetwork?.instagram?.storification?.hasOwnProperty('active')
        ) {
          isActived = this.saveAllFormData.pages[page.id].formDataNetwork.instagram.storification.active
        }else if (saveNetworkIsActiveStory !== null) {
          isActived = saveNetworkIsActiveStory
        }else{
          isActived = defaultActivedShareStory
        }
        console.log("setPagesInstagramActivedShareStory",page.id,isActived)
        return isActived

      })
    },

    generateStoryShare() {
      return
      console.log("generateStoryShare")
      this.setPagesInstagramActivedShareStory()
      const idStickerPost = 1111111111111

      const replaceMentions = (text, mentions) => {
        return text.trim().replace(/@(\d{13})/g, (match, id) => {
          const mention = mentions[id];
          if (mention) {
            return mention.mention && mention.mention.instagram ? `@${mention.mention.instagram.id || mention.mention.instagram.name}` : mention.textDefault;
          }
          return match;
        });
      }

      const getTemplate = (file, typePost, textContent = '', mentions) =>{
        console.log("generateStoryShare getTemplate",file, typePost, textContent, mentions)
        if (mentions) textContent = replaceMentions(textContent.slice(0, 213), mentions).slice(0, 200)
        return {
          "storification":{
            "0":{
              // "background":{"color":"#8A7A54"},
              ...JSON.parse(JSON.stringify(formDataDefault.storification[0])),
              "stickers":{
                [idStickerPost]:{
                  "type":"post",
                  "disableDelete": true,
                  "disableIncreaseZIndex": true,
                  "isEditing":false,
                  "position":{"x":50,"y":50},
                  "transform":{"rotate":0,"scale":1},
                  "data":{
                    url: file.url,
                    width: file.info.width,
                    height: file.info.height,
                    type: file.info.type2,
                    fileType: file.info.type,
                    typePost: typePost,
                    styleVariant: 1,
                    'textContent': textContent
                  },
                  "id": idStickerPost,
                  "zIndex":9
                }
              }
            }
          }
        }
      }
      //Permet de generer les storifications
      //si storification dans le form main et si file alors story
      let files = []
      let template = null

      if (this.pagesInstagramActivedShareStory.length) {
        let formDataRef = deepClone(this.saveAllFormData.main)
        mergeUpdates(formDataRef,this.saveAllFormData.networks['instagram'])


        files = getFilesByNetwork(formDataRef.files, ['instagram'], formDataRef.formDataNetwork, this.files)['instagram']

        if (files.length) {
          let refreshBackgroundColor = true
          const typePost = files.length > 1 ? 'carousel' : files[0].info.type2 == 'video' ? 'reel' : 'simple'

          template = getTemplate(
            files[0],
            typePost,
            unescapeSpecialChars(formDataRef.textContent),
            {
              ...(this.saveAllFormData.main.mentions || {}),
              ...(this.saveAllFormData.networks.instagram ? this.saveAllFormData.networks.instagram.mentions : {}),
            }
          )
          console.log("generateStoryShare template",template)
          //Objectif: garder la story intacte et juste modifier le sticker post
          if (!this.saveAllFormData.main.storification)  this.$set(this.saveAllFormData.main, 'storification', template.storification)
          else if(!this.saveAllFormData.main.storification[0]) this.$set(this.saveAllFormData.main.storification, 0 , template.storification[0])
          else if(!this.saveAllFormData.main.storification[0].stickers) {
            refreshBackgroundColor = false
            this.$set(this.saveAllFormData.main.storification[0], 'stickers' , template.storification[0].stickers)
          }else{
            const stickerPost = this.saveAllFormData.main.storification[0].stickers[idStickerPost]
            if (!stickerPost) {
              this.$set(this.saveAllFormData.main.storification[0].stickers, idStickerPost , template.storification[0].stickers[idStickerPost])
            }else{
              if (this.saveAllFormData.main.storification[0].stickers[stickerPost.id].data.idFile == files[0].id) refreshBackgroundColor = false
              this.$set(this.saveAllFormData.main.storification[0].stickers[stickerPost.id], 'data', {
                ...template.storification[0].stickers[idStickerPost].data,
                styleVariant: this.saveAllFormData.main.storification[0].stickers[stickerPost.id].data.styleVariant || 1

              })
            }
          }


          if (refreshBackgroundColor && files[0].info.averageColor) {
            this.$set(this.saveAllFormData.main.storification[0].background, 'color', files[0].info.averageColor)
          }
        }else{
          this.$delete(this.saveAllFormData.main.storification[0].stickers, idStickerPost)
        }


        //Retire les storification des pages qui ne sont plus active
        Object.keys(this.saveAllFormData.pages).forEach(pageId => {
          let pageIsActived = this.pagesInstagramActivedShareStory.some(page => page.id == pageId)
          if (!pageIsActived && this.saveAllFormData.pages[pageId] && this.saveAllFormData.pages[pageId].storification) {
            this.$delete(this.saveAllFormData.pages[pageId], 'storification')
          }
        })

        //custom page
        this.pagesInstagramActivedShareStory.forEach((page, index) => {

          if (this.saveAllFormData.pages[page.id]) {

            const newTextContent = this.saveAllFormData.pages[page.id] && this.saveAllFormData.pages[page.id].hasOwnProperty('textContent') ? this.saveAllFormData.pages[page.id].textContent : undefined

            let newFiles = []
            if (this.saveAllFormData.pages[page.id].files) {
              newFiles = this.saveAllFormData.pages[page.id].files.filter(({id:idFile}) => (
                ['video', 'image'].includes(this.files[idFile].info.type2) && this.files[idFile].info.type2 !== 'image/gif'
              ))
            }

            if (newFiles.length || files.length) {
              if (!newTextContent) {
                try {
                  this.$delete(this.saveAllFormData.pages[page.id].storification[0].stickers[idStickerPost].data, "textContent")
                } catch (error) { /* ignored */ }
              }

              if (!newFiles.length) {
                try {
                  this.$delete(this.saveAllFormData.pages[page.id].storification[0].stickers[idStickerPost].data, "idFile")
                  this.$delete(this.saveAllFormData.pages[page.id].storification[0].stickers[idStickerPost].data, "typePost")
                } catch (error) { /* ignored */ }
              }



              let refreshBackgroundColor = true
              let typePost = null

              if (newFiles.length) typePost = newFiles.length > 1 ? 'carousel' : this.files[newFiles[0].id].info.type2 == 'video' ? 'reel' : 'simple'
              else typePost = files.length > 1 ? 'carousel' : this.files[files[0].id].info.type2 == 'video' ? 'reel' : 'simple'

              template = getTemplate(
                newFiles.length ? this.files[newFiles[0].id] : this.files[files[0].id],
                typePost,
                newTextContent ? unescapeSpecialChars(newTextContent) : unescapeSpecialChars(formDataRef.textContent),
                {
                  ...(this.saveAllFormData.main.mentions || {}),
                  ...(this.saveAllFormData.networks.instagram ? this.saveAllFormData.networks.instagram.mentions : {}),
                  ...(this.saveAllFormData.pages[page.id].mentions || {}),
                }

              )

              //si le main embarque deja la storification alors on netoie la template
              if (this.saveAllFormData.main.storification[0].stickers[idStickerPost]) {
                template.storification[0] = {
                  stickers: {
                    [idStickerPost]:{
                      data:{}
                    }
                  }
                }

                if (newFiles.length) {
                  template.storification[0].stickers[idStickerPost].data.idFile = newFiles[0].id
                  template.storification[0].stickers[idStickerPost].data.typePost = typePost
                }

                if (newTextContent) {
                  template.storification[0].stickers[idStickerPost].data.textContent = replaceMentions(
                    unescapeSpecialChars(newTextContent),
                    {
                      ...(this.saveAllFormData.main.mentions || {}),
                      ...(this.saveAllFormData.networks.instagram ? this.saveAllFormData.networks.instagram.mentions : {}),
                      ...(this.saveAllFormData.pages[page.id].mentions || {}),
                    }
                  )
                }

              }


              if(!this.saveAllFormData.pages[page.id].storification) {
                this.$set(this.saveAllFormData.pages[page.id], 'storification', template.storification)
              }else if(!this.saveAllFormData.pages[page.id].storification[0]) {
                this.$set(this.saveAllFormData.pages[page.id].storification, 0 , template.storification[0])
              }else if(!this.saveAllFormData.pages[page.id].storification[0].stickers) {
                refreshBackgroundColor = false
                this.$set(this.saveAllFormData.pages[page.id].storification[0], 'stickers' , template.storification[0].stickers)
              }else{

                const stickerPost = this.saveAllFormData.pages[page.id].storification[0].stickers[idStickerPost]
                if (!stickerPost) {
                  this.$set(this.saveAllFormData.pages[page.id].storification[0].stickers, idStickerPost, template.storification[0].stickers[idStickerPost])
                }else{
                  if (
                    newFiles.length &&
                    this.saveAllFormData.pages[page.id].storification[0].stickers[idStickerPost] &&
                    this.saveAllFormData.pages[page.id].storification[0].stickers[idStickerPost].data &&
                    this.saveAllFormData.pages[page.id].storification[0].stickers[idStickerPost].data.idFile &&
                    this.saveAllFormData.pages[page.id].storification[0].stickers[idStickerPost].data.idFile == newFiles[0].id
                  )  {
                    refreshBackgroundColor = false
                  }

                  this.$set(this.saveAllFormData.pages[page.id].storification[0].stickers[idStickerPost], 'data', {
                    ...(this.saveAllFormData.pages[page.id].storification[0].stickers[idStickerPost].data || {}),
                    ...template.storification[0].stickers[idStickerPost].data
                  })
                }
              }

              if (refreshBackgroundColor && newFiles.length && this.files[newFiles[0].id].info.averageColor) {
                if (!this.saveAllFormData.pages[page.id].storification[0].background) {
                  this.$set(this.saveAllFormData.pages[page.id].storification[0], 'background', {color: this.files[newFiles[0].id].info.averageColor})
                }else{
                  this.$set(this.saveAllFormData.pages[page.id].storification[0].background, 'color', this.files[newFiles[0].id].info.averageColor)
                }
              }

            }else{
              this.$delete(this.saveAllFormData.pages[page.id], 'storification')
            }

          }

        });
      }
    },

    removeAllStickersPost() {
      const idStickerPost = 1111111111111
      if (this.saveAllFormData.main && this.saveAllFormData.main.storification && Object.keys(this.saveAllFormData.main.storification).length) {
        Object.keys(this.saveAllFormData.main.storification).forEach(storyId => {
          if (this.saveAllFormData.main.storification[storyId].stickers && Object.keys(this.saveAllFormData.main.storification[storyId].stickers).length) {
            const stickerPost = this.saveAllFormData.main.storification[storyId].stickers[idStickerPost]
            if (stickerPost) {
              this.$delete(this.saveAllFormData.main.storification[storyId].stickers, stickerPost.id)
            }
          }
        })
      }
      if (this.saveAllFormData.pages && Object.keys(this.saveAllFormData.pages).length) {
        Object.keys(this.saveAllFormData.pages).forEach(pageId => {
          if (this.saveAllFormData.pages[pageId].storification && Object.keys(this.saveAllFormData.pages[pageId].storification).length) {
            Object.keys(this.saveAllFormData.pages[pageId].storification).forEach(storyId => {
              if (this.saveAllFormData.pages[pageId].storification[storyId].stickers && Object.keys(this.saveAllFormData.pages[pageId].storification[storyId].stickers).length) {
                const stickerPost = this.saveAllFormData.pages[pageId].storification[storyId].stickers[idStickerPost]
                if (stickerPost) {
                  this.$delete(this.saveAllFormData.pages[pageId].storification[storyId].stickers, stickerPost.id)
                }
              }
            })
          }
        })
      }
    },

    /////////////// SAVE - POSTING ///////////////

    saveDraft() {
      if (this.isFileUploading) {
        EventBus.$emit("showModal", 
            "Media en cours de chargement", 
            "Voulez-vous attendre la fin du chargement avant de sauvegarder ? ", 
            "Attendre", 
            "Sauvegarder quand même",  
            ()=>{
                return
            },
            ()=>{
              this.$emit('saveDraft')
            },
        );
      }else{
        this.$emit('saveDraft')
      }
    },

    sendPostAllPost() {
      this.$emit('sendPostAllPost')
    }
  },

  computed: {
    currentUser() {
      return this.$store.getters['users/getCurrentUser']
    },
    isPrenium() {
      return true
      // return this.currentUser?._premium?.plan > 1;
    },

    allPages() {
      return this.$store.getters['selectPage/selectPageAllPages'];
    },

    pagesSelected() {
      return this.$store.getters['selectPage/selectPagePageSelected'].map(id => this.allPages[id]);
    },

    pagesSelectedIncludeConciergerie() {
      return this.pagesSelected.filter(page => page.network == 'instagram' && page.story_config && page.story_config.created).length
    },

    isFacebookConciergerieEdit() {
      return this.pagesSelected.some(p => p.network === 'facebook' && p.story_config && p.story_config.created);
    },

    networksSelected() {
      return [...new Set(this.$store.getters['selectPage/selectPagePageSelected'].map(id => this.allPages[id].network))];
    },

    phoneIsFirstPlan() {
      let validmodes = ['addCollaboratorMode','addIdentifierMode','addPlaceMode', 'addMusicMode', 'addTiktokMusicMode','addMentionMode','addHashtagMode','addProductMode', 'inputMode']
      return validmodes.find(v => this.modes.includes(v)) ? true : false
    },

    textContentConverted() {

      const regex = /^(<br\s*\/?>|\\n|\s*)+$/i
      if (!this.formData.textContent || regex.test( this.formData.textContent)) return ''

      return this.formData.textContent.replaceAll("\\n", '<br>')
    },

    filesSortByNetwork() {
      return getFilesByNetwork(this.formData.files, this.listNetworkSort, this.formData.formDataNetwork, this.files)
    },

    countDataFormRequestValid() {
      return Object.values(this.dataFormRequest).filter(form => !form.hasOwnProperty('error')).length
    },

    isCurrentUserAssigned() {
      return (
        this.draftInstance.form.planifiedDate.date &&
        this.draftInstance.usersAssigned.length &&
        this.draftInstance.usersAssigned.requiredValidation &&
        this.draftInstance.usersAssigned.includes(this.currentUser.id)
      )
    },

    textSwitchPreview() {
      return 'a revoir'
      if (this.mode == 'update') return this.$t('dash.post-creator.action.update')
      if (this.formData.planifiedDate.date && this.idUsersAssigned.length && this.requiredValidation) {
        if (this.isCurrentUserAssigned){
          return this.$t('dash.post-creator.action.validate')
        }else{
          return this.$t('dash.post-creator.action.send-for-validation')
        }
      }


      let postPlanified = false
      let postInstantly = false

      const formMain = !this.customMode.active ? this.formData : this.saveAllFormData.main

      for (let i = 0; i < this.pagesSelected.length; i++) {
        if (postPlanified && postInstantly) break;
        const page = this.pagesSelected[i];

        const formDataByPage = this.customMode.active && this.customMode.selection.page && this.customMode.selection.page.id == page.id ? this.formData : this.saveAllFormData.pages[page.id]
        const formDataByNetwork = this.customMode.active && this.customMode.selection.network == page.network ? this.formData : this.saveAllFormData.networks[page.network]


        if (formDataByPage && formDataByPage.planifiedDate) {
          if (formDataByPage.planifiedDate.date || formDataByPage.planifiedDate.hours) {
            postPlanified = true
          }else {
            postInstantly = true
          }
        }else if(formDataByNetwork && formDataByNetwork.planifiedDate){
          if (formDataByNetwork.planifiedDate.date || formDataByNetwork.planifiedDate.hours) {
            postPlanified = true
          }else {
            postInstantly = true
          }
        }else{

          if (formMain.planifiedDate.date || formMain.planifiedDate.hours) {
            postPlanified = true
          } else {
            postInstantly = true
          }
        }
      }

      if (postPlanified && postInstantly) {
        return this.$t('dash.post-creator.action.publish-and-schedule');
      } else if (postPlanified) {
        if (this.idUsersAssigned.length && this.requiredValidation && this.idUsersAssigned.includes(this.currentUser.id)) return this.$t('dash.button.schedule')
        if (this.mode == 'edit') return this.$t('dash.post-creator.action.apply')
        return this.$t('dash.button.schedule');
      } else if (postInstantly) {
        return this.$t('dash.post-creator.action.publish');
      }

      return '';
    },

    textBtnFinish() {
      if (this.mode == 'update')  {
        const pagesCount = this.pagesSelected.filter(page =>
          this.editableNetworks.includes(page.network) &&
          this.dataFormRequest[page.id] && !this.dataFormRequest[page.id].hasOwnProperty('error')
        ).length

        return `${this.$t(pagesCount > 1 ? 'dash.post-creator.action.update-on-pages' : 'dash.post-creator.action.update-on-page', { count: pagesCount })}`
      }

      if (this.draftInstance.form.planifiedDate.date && this.draftInstance.usersAssigned.length && this.draftInstance.usersAssigned.requiredValidation) {
        if (this.draftInstance.usersAssigned.includes(this.currentUser.id)) {
          return this.$t('dash.post-creator.action.validate')
        }else{
          return this.$t('dash.post-creator.action.send-for-validation')
        }

      }
      
      if (this.requests?.posts) {
        const forms = Object.values(this.requests.posts);

        const postPlanified = forms.filter(form => !form.hasOwnProperty('error') && form.scheduled);
        const postInstantly = forms.filter(form => !form.hasOwnProperty('error') && !form.scheduled);

        if (postPlanified.length && postInstantly.length) {
          return this.$t('dash.post-creator.action.publish-and-schedule');
        } else if (postPlanified.length) {
          return `${this.$t(postPlanified.length > 1 ? 'dash.post-creator.action.schedule-on-pages' : 'dash.post-creator.action.schedule-on-page', { count: postPlanified.length })}`;
        } else if (postInstantly.length) {
          return `${this.$t(postInstantly.length > 1 ? 'dash.post-creator.action.publish-on-pages' : 'dash.post-creator.action.publish-on-page', { count: postInstantly.length })}`;
        }
      }

      return '';
    },

    textPostFailed () {
      if (this.previewMode.active) {
        if (this.requests?.posts?.[this.draftInstance.form.merge.target?.id] instanceof Error) {
          return this.requests.posts[this.draftInstance.form.merge.target?.id].message
        }
      } else {
        if (this.draftInstance.form.merge.target == 'main') {
          if (this.typeNetworkSelected) {
            return this.draftInstance.form.networks[this.typeNetworkSelected]?.validator?.error
          }
        } else {
          if (this.draftInstance.form.merge.target.id) {
            return this.draftInstance.form.networks[this.draftInstance.form.merge.target.network].validator.error
          } else {
            return this.draftInstance.form.networks[this.draftInstance.form.merge.target].validator.error
          }
        }  
      }

      return ''
    },

    title () {

      switch (this.mode) {
        case "edit":
          return this.$t('dash.post-creator.title.edit-mode')
        case "draft":
          return this.$t('dash.post-creator.title.draft')
        case "update":
          return this.$t('dash.post-creator.title.update-post')
        default:
          return this.previewMode.active ? this.$t('dash.post-creator.title.preview') : this.$t('dash.post-creator.title.new')

      }


    },

    storificationActived() {
      return this.formData.formDataNetwork.instagram.storification.active ||
        (this.saveAllFormData.networks.instagram &&
          this.saveAllFormData.networks.instagram.formDataNetwork &&
          this.saveAllFormData.networks.instagram.formDataNetwork.instagram.storification &&
          this.saveAllFormData.networks.instagram.formDataNetwork.instagram.storification.active)
    },

    pageForRenderPost() {
      //retourne un array de page a prendre en compte pour le rendu du post
      if (this.previewMode.active) return [this.previewMode.pageSelected]
      else if (this.draftInstance.form.merge.target.id) return [this.draftInstance.form.merge.target]
      else return this.draftInstance.pages.filter(p => p.network == this.typeNetworkSelected)
    },

    idsPagesEditedForRenderPost() {
      //retourne un array de page qui on une personalisation active a prendre en compte pour le rendu du post
      if (this.previewMode.active) return []

      return this.draftInstance.pages.filter((p) => {
        return (  
          this.draftInstance.form.merge.saveAllFormData.pages[p.id]
        )
      }).map(p => p.id)
    },

    postNetworkIsValid() {
      const validator = postNetworkValidator(this.listNetworkSort,  this.filesSortByNetwork,  this.formData.formDataNetwork , this.textContentConverted)
      return validator
    },

    switchModeShow() {
      if (!this.draftInstance) return false
      return customModeIsAvailable({
        draftInstance: this.draftInstance,
      })
    },

    countPagePerNetwork() {
      return this.pagesSelected.reduce((count, page) => {
        count[page.network] = (count[page.network] || 0) + 1;
        return count;
      }, {})
    },
  },



  watch: {
    networksSelected(newValue, oldValue) {
      this.updateTypeNetworkSelected()
    },

    postNetworkIsValid(validator) {
      console.log('postNetworkIsValid changed')
      this.updateTypeNetworkSelected()
    },


    ["formData.formDataNetwork.instagram.storification.active"]: {
      handler() {
        this.setPagesInstagramActivedShareStory()
      },
      immediate: true
    },

    ["previewMode.active"]: {
      handler(value, oldValue) {
        
        console.log('previewMode.active changed', value, oldValue, this.previewMode, this.draftInstance.form.merge.target)
        if (value) {

          this.formShow = this.draftInstance.form.merge.target == 'main' ? "preview-right" : "preview-left"
          // if (this.previewMode.pageSelected) this.draftInstance.form.merge.run(this.previewMode.pageSelected)

          if (oldValue == undefined) {
            this.formShow += ` annimate-switch-preview-mode`
          }else{
            console.log('previewMode.active changed else', this.draftInstance.form.merge.target)

            if (this.timeOutAnnimateForm) clearTimeout(this.timeOutAnnimateForm)
            this.$nextTick(() => {
              this.timeOutAnnimateForm = setTimeout(() => {
                if (this.$refs.postCreator && this.$refs.postCreator.classList) {
                  this.$refs.postCreator.classList.add('annimate-switch-preview-mode');
                }
              }, 500);
            })
          }

        }else{

          if (this.formShow == "preview-right") this.draftInstance.form.merge.run('main')
          
          if (this.$refs.postCreator && this.$refs.postCreator.classList) {
            this.$refs.postCreator.classList.remove('annimate-switch-preview-mode');
          }

          if (this.timeOutAnnimateForm) clearTimeout(this.timeOutAnnimateForm)
          this.$nextTick(() => {
            this.timeOutAnnimateForm = setTimeout(() => {
              if (this.formShow.startsWith("preview-left")) {
                this.formShow = "formUnique"
              }else{
                this.formShow = "formMultiple"
              }
            }, 1000);
          })
        }
      },
      immediate: true
    },

    customModeIsAvailable: {
      handler(value) {
        this.setPagesInstagramActivedShareStory()
      },
      immediate: true
    }
  },



  beforeDestroy () {
    EventBus.$off('postCreatorAddMode', this.addMode);
    EventBus.$off('postCreatorRemoveMode', this.removeMode);
  },

  beforeUpdate() {
    this.renderCount++
    console.time(`StandardTab render #${this.renderCount}`)
  },

  updated() {
    console.timeEnd(`StandardTab render #${this.renderCount}`)
    console.log(`StandardTab total renders: ${this.renderCount}`)
  },

}
</script>
